<template>
    <div class="container mt-5">
        <h1>Our banners</h1>
    </div>
</template>

<script>
    export default {
        name: "Banner",
        metaInfo: {
            title: 'Banner'
        }
    }
</script>

<style scoped>

</style>
